import styled from '@emotion/styled'
import {
  Form as AntdForm,
  Input as AntdInput,
  Radio as AntdRadio,
  TimePicker as AntdTimePicker,
  Select as AntdSelect,
  Checkbox as AntdCheckbox,
} from 'antd'
import BuddhistDatePicker from '@/components/common/BuddhistDatePicker/BuddhistDatePicker'

export const Container = styled('div')`
  padding: 32px;
  width: 100%;
  border-radius: 8px;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
  background-color: white;
`

export const Title = styled('div')`
  font-size: 20px;
  font-weight: 400;
  margin-bottom: 32px;
`

export const Form = styled(AntdForm)``

export const RadioGroup = styled(AntdRadio.Group)``

export const Radio = styled(AntdRadio)``

export const TimePicker = styled(AntdTimePicker)`
  width: 100%;
`

export const DatePicker = styled(BuddhistDatePicker)`
  width: 100%;
  height: 42px;
  border-radius: 8px;
`

export const TextArea = styled(AntdInput.TextArea)`
  //min-height: 104px !important;
  width: 100%;
`

export const Select = styled(AntdSelect)`
  width: 100%;

  .ant-select-selector {
    height: 42px !important;
    border-radius: 8px !important;
    display: flex;
    align-items: center;
    position: relative;
  }

  .ant-select-selection-item {
    font-size: 14px !important;
  }

  /* Hide the default selection display when we have custom content */
  &.custom-display .ant-select-selection-item {
    display: none;
  }

  /* Adjust height for custom displays */
  &.hospital-select .ant-select-selector {
    height: 60px !important;
  }

  &.disease-select .ant-select-selector {
    height: 80px !important;
  }

  /* Dropdown styling */
  .ant-select-dropdown {
    border-radius: 8px !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  }

  .ant-select-item {
    border-radius: 0 !important;
  }

  .ant-select-item:first-child {
    border-top-left-radius: 8px !important;
    border-top-right-radius: 8px !important;
  }

  .ant-select-item:last-child {
    border-bottom-left-radius: 8px !important;
    border-bottom-right-radius: 8px !important;
  }
`

export const Option = styled(AntdSelect.Option)`
  padding: 12px 16px !important;
  min-height: 60px !important;
  border-bottom: 1px solid #f0f0f0 !important;

  &:hover {
    background-color: #f5f5f5 !important;
  }

  &:last-child {
    border-bottom: none !important;
  }
`

export const OptionContent = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`

export const OptionCode = styled('div')`
  font-size: 12px;
  color: #666666;
  font-weight: 500;
  line-height: 1.2;
`

export const OptionName = styled('div')`
  font-size: 14px;
  color: #000000;
  font-weight: 400;
  line-height: 1.3;
`

export const OptionEnglishName = styled('div')`
  font-size: 12px;
  color: #999999;
  font-weight: 400;
  line-height: 1.2;
  text-transform: uppercase;
`

export const CustomSelectionDisplay = styled('div')`
  position: absolute;
  top: 8px;
  left: 12px;
  right: 32px;
  pointer-events: none;
  z-index: 1;
`

export const SelectionCode = styled('div')<{ disabled?: boolean }>`
  font-size: 12px;
  color: ${(props) => (props.disabled ? '#bfbfbf' : '#666666')};
  line-height: 1.2;
`

export const SelectionName = styled('div')<{ disabled?: boolean }>`
  font-size: 14px;
  color: ${(props) => (props.disabled ? '#bfbfbf' : '#000000')};
  font-weight: 400;
  line-height: 1.2;
  margin-top: 2px;
`

export const SelectionEnglishName = styled('div')<{ disabled?: boolean }>`
  font-size: 12px;
  color: ${(props) => (props.disabled ? '#d9d9d9' : '#999999')};
  line-height: 1.2;
  margin-top: 1px;
`

export const Checkbox = styled(AntdCheckbox)`
  font-size: 14px;

  .ant-checkbox-inner {
    border-radius: 4px;
  }
`

export const HospitalSelectContainer = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const DiseaseInfoContainer = styled('div')`
  padding: 16px;
  padding-left: 0;
  border-radius: 8px;
  margin-bottom: 16px;
`

export const DiseaseLabel = styled('div')`
  font-size: 14px;
  color: #666666;
  margin-bottom: 4px;
`

export const DiseaseName = styled('div')`
  font-size: 14px;
  font-weight: 500;
  color: #000000;
`
